const MAX_INITIALS = 3;

/**
 * Placeholder shown in a party avatar when there is no logo to display.
 *
 * Prefers the party's own abbreviation, since that is the branding the party
 * actually uses. Falls back to initials derived from the name so an avatar is
 * never blank — most parties in the dataset have no logo uploaded, and some
 * have no abbreviation either.
 */
export function partyInitials(party: {
  name?: string | null;
  abbreviation?: string | null;
}): string {
  const abbreviation = party.abbreviation?.trim();
  if (abbreviation) return abbreviation.toUpperCase();

  // Words only: punctuation-only tokens (e.g. the "-" in "Labor - Vic") would
  // otherwise contribute a stray character to the initials.
  return (party.name ?? '')
    .split(/\s+/)
    .map((word) => word.replace(/[^\p{L}\p{N}]/gu, '').charAt(0))
    .filter(Boolean)
    .slice(0, MAX_INITIALS)
    .join('')
    .toUpperCase();
}
